(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
         .state('eodbtotaldeptservicesdetailyearly', {
          parent: 'eodbdashboardyearly',
          url: '/eodbdashboardcafsYearlyByElasticByStatus/{departmentName}/{district}/{projectLevel}/{serviceId}/{status}',
          data: {
              authorities: []
          },
          onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
              $uibModal.open({
                  templateUrl: 'app/eodbtotaldeptservicesdetailyearly/eodbtotaldeptservicesdetailyearly.html',
                  controller: 'EodbTotalDeptServicesDetailYearlyController',
                  controllerAs: 'vm',
                  backdrop: 'static',
                  size: 'lg',
                  windowClass: 'app-modal-window',
                  resolve: {
                      translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                          $translatePartialLoader.addPart('dashboard');
                          return $translate.refresh();
                      }]
                  }
              }).result.then(function() {
                  $state.go('eodbdashboardyearly', null, { reload: 'eodbdashboardyearly' });
              }, function() {
                  $state.go('eodbdashboardyearly');
              });
          }]
      });
    }
})();
